<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-col">
          <div class="footer-logo">
            <img src="@/assets/images/Home_logo2.svg" alt="GodGreek Logo" />
            <!-- <span class="footer-logo-text">GodGreek</span> -->
          </div>
          <p class="footer-about">
            Experience top-notch gaming at GodGreek with PC games, PS5, and a
            high-tech gaming cockpit!
          </p>
        </div>
        <div class="footer-col">
          <h4>Useful links</h4>
          <div class="footer-links">
            <div class="footer-link-row">
              <a
                href="javascript:void(0)"
                class="nav-link"
                @click="scrollToSection('home')"
                >Home</a
              >
            </div>
            <div class="footer-link-row">
              <a
                href="javascript:void(0)"
                class="nav-link"
                @click="scrollToSection('about')"
                >About</a
              >
            </div>
            <div class="footer-link-row">
              <a
                href="javascript:void(0)"
                class="nav-link"
                @click="scrollToSection('games')"
                >Games</a
              >
            </div>
            <div class="footer-link-row">
              <a @click="onClickRulesndRegulations">Rules & Regulations</a>
            </div>
            <div class="footer-link-row">
              <a @click="onClickTerms">Terms & condition</a>
            </div>
            <div class="footer-link-row">
              <a @click="onClickPrivacy">Privacy Policy</a>
            </div>
            <div class="footer-link-row">
              <a @click="onClickContactUs">Contact us</a>
            </div>
          </div>
        </div>
        <div class="footer-col">
          <div class="footer-info">
            <h4>Contact</h4>
            <p>
              <a
                href="tel:+918780529023"
                style="color: #d4d5d9; text-decoration: none"
              >
                +91 87805 29023
              </a>
            </p>
          </div>
          <div class="footer-info">
            <h4>Email</h4>
            <p>
              <a
                href="mailto:help@godgreekgaming.com"
                style="color: #d4d5d9; text-decoration: none"
              >
                help@godgreekgaming.com
              </a>
            </p>
          </div>
          <div class="footer-info">
            <h4>Opening hours</h4>
            <!-- <p>9 AM to 1 AM</p> -->
            <p>12 PM to 4 AM</p>
          </div>
        </div>
        <div class="footer-col">
          <div class="footer-info">
            <h4>Address</h4>
            <p>
              1st floor, SK house, opposite Drive In Cinema, Drive In Road,
              Ahmedabad, Gujarat, India
            </p>
          </div>
        </div>
        <div class="footer-col">
          <button class="scroll-to-top" @click="scrollToTop">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <circle cx="20" cy="20" r="20" fill="#D4D5D9" />
              <path
                d="M20 27L20 13M20 13L14 19M20 13L26 19"
                stroke="#18191B"
                stroke-width="1.5"
              />
            </svg>
          </button>
        </div>
      </div>
      <div class="footer-last">
        This website is managed by
        <span class="ftr_title"> PATEL DHARMENDRA</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    scrollToSection(sectionId) {
      if (this.$route.path !== "/Home") {
        this.$router.push({ path: "/Home", hash: `#${sectionId}` });
      } else {
        const el = document.getElementById(sectionId);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
    },
    onClickPrivacy() {
      this.$router.push({ name: "PrivacyPolicy" });
    },
    onClickTerms() {
      this.$router.push({ name: "TermsCondition" });
    },
    onClickContactUs() {
      this.$router.push({ name: "ContactUs" });
    },
    onClickRulesndRegulations() {
      this.$router.push({ name: "RulesandRegulations" });
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 80px;
}

/* Footer */
.footer {
  background: black;
  padding: 24px 0;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  content: center;
  gap: 40px;
}

.footer-col {
  flex: 1 1 220px;
}

.footer-col h4 {
  color: #fff;
}

.footer-about {
  color: #fff;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 40px;
}

.footer-logo-img {
  width: 76px;
  height: 47px;
}

.footer-logo-text {
  font-family: "Barlow", sans-serif;
  font-size: 30px;
  color: #fff;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: "Barlow", sans-serif;
}

.footer-link-row {
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
}

.footer-links a {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}

.footer-link-row a {
  color: #d4d5d9;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  line-height: 140%;
  transition: color 0.3s ease;
}

.footer-link-row a:hover {
  color: #fff;
}

.footer-link-row span {
  color: #d4d5d9;
  opacity: 0.4;
  font-size: 14px;
  font-family: "Barlow", sans-serif;
}

.footer-info {
  margin-bottom: 32px;
}

.footer-info h4,
.footer-col h4 {
  color: #fff;
  font-size: 14px;
  font-weight: bolder;
  letter-spacing: 0.56px;
  text-transform: uppercase;
  margin-bottom: 8px;
  font-family: "Barlow", sans-serif;
}

.footer-info p {
  color: #d4d5d9;
  font-size: 16px;
  line-height: 140%;
  font-family: "Barlow", sans-serif;
}

.footer-about {
  font-family: "Barlow", sans-serif;
  color: #d4d5d9;
}

.scroll-to-top {
  background: none;
  border: none;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.scroll-to-top:hover {
  transform: translateY(-2px);
}

/* Tablet & Mobile Fix */
@media (max-width: 991px) {
  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 20px;
  }

  .footer-col {
    width: 100%;
    flex: unset;
    margin-bottom: 10px;
  }

  .footer-info {
    margin-bottom: 16px;
  }

  .footer-logo {
    justify-content: center;
    margin-bottom: 20px;
  }

  .footer-links {
    align-items: center;
    gap: 6px;
  }
}

@media (max-width: 480px) {
  .footer-content {
    gap: 12px;
  }

  .footer-info p {
    font-size: 14px;
  }
}

.footer-last {
  display: flex;
  justify-content: center;
  color: white;
  flex-wrap: nowrap;
  white-space: nowrap;
  font-size: 14px;
}

.ftr_title {
  font-weight: bold;
  margin-left: 5px;
}
</style>
